export default {
	id: 'SIMPLE_PAYWALL_1M_29_99_12M_12_00',
	providers: {
		paltaMap: {
			USD: 'simple_premium_comm_1m_29_99_12m_12_usd',
		},
		primer: 'prd_l5raLi7in0Tp',
	},
	model: {
		commitment_period: 12,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 12,
		},
		originalPriceMap: {
			USD: 29.99,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		footerPeriodText: '12-month', // 12-month
		footerIntervalText: $t('pages.program.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
	}),
}
